// src/firebaseConfig.js (Create this file)
// --------------------------------------------------
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // Import getAuth and GoogleAuthProvider
import { getFirestore } from "firebase/firestore"; // Import getFirestore
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFsE3_VmKVzerI27JAnJiIVP5_ST4aDus",
  authDomain: "examengine-48383.firebaseapp.com",
  projectId: "examengine-48383",
  storageBucket: "examengine-48383.firebasestorage.app",
  messagingSenderId: "846010488092",
  appId: "1:846010488092:web:2be47df988aca7a62556d9",
  measurementId: "G-M4GLR4LD5V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // Optional: if you use analytics

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app); // Initialize and export auth
export const googleProvider = new GoogleAuthProvider(); // Export Google provider
export const db = getFirestore(app); // Initialize and export Firestore